"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var easeInOutQuad = function (percentage) {
    return percentage < 0.5 ? 2 * percentage * percentage : -1 + (4 - 2 * percentage) * percentage;
};
var ScrollMoveType;
(function (ScrollMoveType) {
    ScrollMoveType["LEFT"] = "LEFT";
    ScrollMoveType["CENTER"] = "CENTER";
})(ScrollMoveType = exports.ScrollMoveType || (exports.ScrollMoveType = {}));
exports.smoothScroll = function (scrollArea, offsetLeft, offsetWidth, duration, type, callback) {
    if (duration === void 0) { duration = 20; }
    if (!scrollArea)
        return;
    var elementOffset = offsetLeft || 0;
    var elementWidth = offsetWidth || 0;
    var positionOffset = type === ScrollMoveType.CENTER ? scrollArea.clientWidth / 2 - elementWidth / 2 : 0;
    var end = elementOffset - positionOffset;
    var start = scrollArea.scrollLeft;
    var finish = Math.min(scrollArea.scrollWidth, Math.max(0, end));
    var distance = Math.abs(finish - start);
    var time = 0;
    var runAnimation = null;
    var animateScroll = function () {
        time = time + 1;
        var percentage = Math.min(1, time / duration);
        var change = distance * easeInOutQuad(percentage);
        scrollArea.scrollLeft = start > finish ? start - change : start + change;
        if (time >= duration || change === 0) {
            runAnimation && clearInterval(runAnimation);
            if (callback) {
                callback();
            }
            return;
        }
        window.requestAnimationFrame && window.requestAnimationFrame(animateScroll);
    };
    if (window.requestAnimationFrame) {
        window.requestAnimationFrame(animateScroll);
        return;
    }
    runAnimation = setInterval(animateScroll, 20);
};
exports.smoothScrollToLeft = function (target, duration) {
    if (duration === void 0) { duration = 20; }
    if (!target)
        return;
    var scrollArea = target.parentNode;
    var offsetLeft = target.offsetLeft || 0;
    var offsetWidth = target.offsetWidth || 0;
    exports.smoothScroll(scrollArea, offsetLeft, offsetWidth, duration, ScrollMoveType.LEFT);
};
exports.smoothScrollToCenter = function (target, duration, callback) {
    if (duration === void 0) { duration = 20; }
    if (!target)
        return;
    var scrollArea = target.parentNode;
    var offsetLeft = target.offsetLeft || 0;
    var offsetWidth = target.offsetWidth || 0;
    exports.smoothScroll(scrollArea, offsetLeft, offsetWidth, duration, ScrollMoveType.CENTER, callback);
};
//# sourceMappingURL=smoothScroll.js.map